
<div class="m-auto container text-center mt-5">

    <div class="card login-form border-0  m-auto">

      <div class="card-header border-0 bg-none mt-3">
        <h5 class="text-center"> 
          <img src="https://ajaraheritage.ge/icons/light.png" class="logo-auth">
        </h5>
      </div>
      
      <span class="text-danger" *ngIf="this.admin.error?.message">მომხმარებელი არ არსებობს</span>
      <div class="card-body p-0 mt-3">

        <form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">

          <div class="form-floating mb-3">
            <input
              [ngClass]="{'is-invalid': this.admin.error?.message}"
              type="text"
              class="form-control"
              formControlName="user"
              id="user"
              placeholder="ლოგინი"
              required>
            <label for="user">ლოგინი</label>
            <div class="invalid-feedback">
              {{this.admin.error?.error?.user}}
            </div>
          </div>

          <div class="form-floating mb-3">
            <input
              [ngClass]="{'is-invalid': this.admin.error?.message}"
              type="password"
              class="form-control"
              formControlName="password"
              id="password"
              placeholder="პაროლი"
              required
              autocomplete="current-password">
            <label for="password">პაროლი</label>
            <div class="invalid-feedback">
              {{this.admin.error?.error?.password}}
            </div>
          </div>

          <div class="form-floating mb-3">
            <button
              class="btn btn-lg w-100 btn-primary rounded-3"
              [disabled]="!validateForm.valid || admin.loading">
              <span *ngIf="admin.loading" class="spinner-border spinner-border-sm" role="status" ></span>
              შესვლა
            </button>
          </div>
          

        </form>

      </div>

    </div>

</div>

